var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardAthletic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 112,
    viewBox: "0 0 190 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 112,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.529 112H17.4752C8.09848 112 0.501953 104.561 0.501953 95.379V16.622C0.501953 7.4396 8.09848 0.000488281 17.4752 0.000488281H172.529C181.905 0.000488281 189.502 7.4396 189.502 16.622V95.379C189.51 104.561 181.905 112 172.529 112Z",
    fill: "url(#paint0_radial_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9939 15.805H26.9277V14.7866C28.8046 14.7866 30.3976 14.7866 32.2824 14.7866V15.805H30.2162V20.731H28.986V15.805H28.9939Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4651 20.7467V18.339H34.2712V20.7467H33.041V14.7944H34.2712V17.3048H37.4651V14.7944H38.6796V20.7467H37.4651Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0623 14.7867V19.6969H44.406V20.7311H39.832V14.7788H41.0623V14.7867Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1295 20.7311H45.2559C45.2559 18.7496 45.2559 16.7603 45.2559 14.7788H50.1295V15.8682H46.4782V17.2418H50.0033V18.2839H46.4782V19.6259H50.1295V20.7311Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1404 15.805H51.0742V14.7866C52.9511 14.7866 54.5441 14.7866 56.4289 14.7866V15.805H54.3627V20.731H53.1325L53.1404 15.805Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1798 20.7308V14.7865H58.4022V20.7387L57.1798 20.7308Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2955 19.9887C64.6252 20.5887 63.7656 20.8729 62.8193 20.8729C60.3983 20.8729 59.381 19.3493 59.3731 17.802C59.3652 16.2468 60.4692 14.668 62.8193 14.668C63.7025 14.668 64.5385 14.9758 65.2088 15.5758L64.3886 16.2942C63.9628 15.9153 63.3871 15.7337 62.8193 15.7337C61.25 15.7337 60.5718 16.8073 60.5797 17.802C60.5875 18.7888 61.2105 19.815 62.8193 19.815C63.3871 19.815 64.0259 19.6019 64.4596 19.2072L65.2955 19.9887Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9542 18.7498H22.9699H22.9542H26.7631L27.8278 20.7313H26.4635L25.9114 19.7919H22.4573L21.8895 20.7313H20.541L23.5062 14.7869H24.8074L22.9542 18.7498Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M99.851 71.4203H100.056H99.851H148.248L161.78 96.6346H144.486L137.42 84.6985H93.5027L86.3106 96.6346H69.1426L106.822 21.0312H123.352L99.851 71.4203Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.0046 56.0017) scale(78.1057 76.4872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#350559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210338"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAthletic);
export default __webpack_public_path__ + "static/media/card-athletic.008d96f1438ddf835e8f8d50f6d134ca.svg";
export { ForwardRef as ReactComponent };